import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const Reply = ({ width = 16, height = 16, fillColor }: BaseSVGType) => {
  return (
    <svg
      fill={fillColor}
      width={width}
      height={height}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      xmlSpace="preserve"
    >
      <path d="M185.2,128.6V19.7L0,204.9l185.2,185.2V281.1c152.5,0,250.5,0,326.8,217.9C512,390.1,522.9,128.6,185.2,128.6z" />
    </svg>
  );
};

export default Reply;